/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Step4_TitleInputs */

const es_cap_step4_title = /** @type {(inputs: Cap_Step4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegas y cobras`)
};

const gl_cap_step4_title = /** @type {(inputs: Cap_Step4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegas e cobras`)
};

const en_cap_step4_title = /** @type {(inputs: Cap_Step4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sail and get paid`)
};

/**
* | output |
* | --- |
* | "Sail and get paid" |
*
* @param {Cap_Step4_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_step4_title = /** @type {((inputs?: Cap_Step4_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Step4_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_step4_title(inputs)
	if (locale === "en") return en_cap_step4_title(inputs)
	return es_cap_step4_title(inputs)
});